import { Col, Row } from '@portalterreno/react-ui-core/Grid';
import React, { memo } from 'react';

import { OnBoardingNavigateProps } from '../OnBoardingNavigate';
import StyledOnBoardingNavigate from '../StyledOnBoardingNavigate';
import StyledDiv from './StyledDiv';
import VerticalCenterDiv from './VerticalCenterDiv';

export type WrapperProps =
  | React.PropsWithChildren<
      Partial<{ [P in keyof OnBoardingNavigateProps]: undefined }>
    >
  | React.PropsWithChildren<OnBoardingNavigateProps>;

const Wrapper: React.FC<WrapperProps> = ({
  children,
  navigateURL,
  navigationPrimaryText,
  navigationSecondaryText
}) => {
  return (
    <StyledDiv>
      <Row>
        <Col>
          {navigateURL && (
            <StyledOnBoardingNavigate
              navigateURL={navigateURL}
              navigationPrimaryText={navigationPrimaryText}
              navigationSecondaryText={navigationSecondaryText}
            />
          )}
        </Col>
      </Row>
      <VerticalCenterDiv>
        <Row>
          <Col
            offset={{ lg: 3 }}
            lg={6}
            xs={4}
          >
            {children}
          </Col>
        </Row>
      </VerticalCenterDiv>
    </StyledDiv>
  );
};

export default memo(Wrapper);
